import { View, Text, StyleSheet } from "react-native";
import { spacing, colors, typographyScale } from "../../../../styles/design-system";
import { TodoCard } from "../../interfaceComponents/todoCard/TodoCard";
import { Todo } from "../../../../graphql/generated/graphql";

interface TodoCardListProps {
  categoryName?: string;
  todos: Todo[];
  toggleCompletion: (id: string, value: boolean) => void;
  discussTask?: (id: string) => void;
  onEdit?: (todo: Todo) => void;
}

export const TodoCardList = ({ categoryName, todos, toggleCompletion, discussTask, onEdit }: TodoCardListProps) => {
  return (
    <View style={styles.container} role="list" accessibilityRole="list">
      {!!categoryName && <Text style={styles.titleText}>{categoryName}</Text>}
      {todos.map((todo) => (
        <TodoCard
          key={todo.id}
          todo={todo}
          workspaceName={todo.workspacesHasTodo?.[0]?.name}
          toggleCompletion={toggleCompletion}
          discussTask={discussTask}
          onEdit={onEdit}
        />
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: spacing.sm,
  },
  titleText: {
    color: colors.grey[900],
    fontSize: typographyScale.textSm.fontSize,
    fontWeight: "600",
  },
});
